let key = {};
// if (process.env.NODE_ENV === "production") {
if (process.env.REACT_APP_MODE === "production") {
  console.log("Set Production Config");
  const API_URL = "https://prodapi.mgassetmanagement.com"
  key = {
    secretOrKey: "FxUum76z",
    API_URL: `${API_URL}`,
    FRONT_URL: "https://mgassetmanagement.com",
    SOCKET_URL: `${API_URL}`,
    TRADE_URL: "http://54.211.230.83:8081/api/trade",
    getGeoInfo: "https://ipapi.co/json/",
  };
}else if (process.env.REACT_APP_MODE === "demo") {
  console.log("Set demo Config");
  const API_URL = "https://mgassetmanagementapi.wearedev.team"
  key = {
    secretOrKey: "FxUum76z",
    API_URL: `${API_URL}`,
    FRONT_URL: "https://mgassetmanagement-com-frontend-2026.pages.dev",
    SOCKET_URL:`${API_URL}`,
    TRADE_URL: "http://54.211.230.83:8081/api/trade",
    getGeoInfo: "https://ipapi.co/json/",
  };
} else {
  console.log("Set Development Config");
  const API_URL = "http://localhost";
  const PORT = 2055;
  key = {
    secretOrKey: "FxUum76z",
    API_URL: `${API_URL}:${PORT}`,
    SOCKET_URL: `${API_URL}:${PORT}`,
    FRONT_URL: "http://localhost:3000",
    TRADE_URL: "http://54.211.230.83:8081/api/trade",
    getGeoInfo: "https://ipapi.co/json/",

  };
}

export default key;
